
const statusCli = [
  {
    id: null,
    status: 'Activos'
  },
  {
    id: '3',
    status: 'Clientes potenciales'
  },
  {
    id: '0',
    status: 'Eliminados/Desactivados'
  },
  {
    id: '4',
    status: 'Por verificar'
  }
]

export { statusCli }
